import styled from "@emotion/styled"
import { Container, Typography } from "@mui/material"
import SeoMetaData from "common/SeoMetaData"
import {
  StaticPropsFactory,
  StaticPropsFactoryProps,
} from "common/StaticPropsFactory"
import RecallForm from "components/Recall/RecallForm"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    text-align: left; /* flipped by mui */
  `,
  Title: styled(Typography)`
    margin-top: 40px;
  `,
  Subtitle: styled(Typography)`
    font-size: 18px;
    margin-top: 10px;
    color: ${(p) => p.theme.colors.marine};
  `,
  Description: styled(Typography)`
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 25px;
    color: ${(p) => p.theme.colors.bluishGrey};
    ${(p) => p.theme.breakpoints.up("md")} {
      margin-top: 5px;
    }
  `,
}

export const getStaticProps = StaticPropsFactory("recall")

const Recall = ({ seo }: StaticPropsFactoryProps) => {
  return (
    <Styled.Wrapper>
      <SeoMetaData data={seo} />
      <Container>
        <Styled.Title variant="h1">קריאות חוזרות</Styled.Title>
        <Styled.Subtitle>
          קריאה חוזרת הינה פניה יזומה של יצרן הרכב אל בעל הרכב שמטרתה ביצוע ללא
          דיחוי של בדיקה ו/או פעולה מונעת ו/או תיקון ברכב לפי מקרה.
        </Styled.Subtitle>
        <Styled.Description>
          על פי תקנה 306 א לתקנות התעבורה, משרד התחבורה לא יחדש את רישיון הרכב
          ולא יאפשר העברת בעלות ברכב שבעליו לא יבצע בפועל את תיקון תקלת הבטיחות
          הסדרתית תוך 6 חודשים ממועד קבלת מכתב ממשרד התחבורה בעניין זה.
        </Styled.Description>
        <Shared.SimpleDivider />
      </Container>
      <RecallForm />
    </Styled.Wrapper>
  )
}

export default Recall
